export default {
  tenantRole: {
    PLATFORM_OPERATOR: "Operador de Plataforma",
    PLANT_OPERATOR: "Operador de Planta",
    RESCUE_SERVICE: "Servicio de Rescate",
    SERVICE_COMPANY: "Empresa de Servicios",
  },
  approvalStatus: {
    PENDING: "Pendiente",
    APPROVED: "Aprobado",
    DENIED: "Denegado",
    PENDING_INVITATION: "Invitación Pendiente",
    WITHOUT_EA_APPROVAL: "Sin Aprobación de EA",
  },
};
